class EscapePincodeChecker extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[data-pincode-input]");
    this.button = this.querySelector("[data-pincode-check]");
    this.successEl = this.querySelector("[data-pincode-success]");
    this.errorEl = this.querySelector("[data-pincode-error]");
    this.resultWrap = this.querySelector("[data-pincode-result]");
    this.apiUrl = (this.dataset.apiUrl || "").trim();

    if (!this.input || !this.button) return;

    this.button.addEventListener("click", () => this.checkPincode());
    this.input.addEventListener("input", () => {
      this.input.value = this.input.value.replace(/\D/g, "");
    });
  }

  msg(key, fallback) {
    return this.dataset[key] || fallback;
  }

  isValidPincodeFormat(pincode) {
    return /^[0-9]{6}$/.test(pincode);
  }

  hideAll() {
    this.resultWrap?.classList.add("always-hidden");
    this.successEl?.classList.add("always-hidden");
    this.errorEl?.classList.add("always-hidden");
  }

  showError(message) {
    this.resultWrap?.classList.remove("always-hidden");
    this.successEl?.classList.add("always-hidden");
    this.errorEl?.classList.remove("always-hidden");
    if (this.errorEl) this.errorEl.textContent = message;
  }

  showSuccess(message) {
    this.resultWrap?.classList.remove("always-hidden");
    this.successEl?.classList.remove("always-hidden");
    this.errorEl?.classList.add("always-hidden");
    if (message && this.successEl) this.successEl.textContent = message;
  }

  async checkViaEscapeApi(pincode) {
    const url = new URL(this.apiUrl, window.location.origin);
    url.searchParams.set("pincode", pincode);
    const response = await fetch(url.toString());
    if (!response.ok) throw new Error("api");
    const data = await response.json();
    const ok = data.ok === true || data.serviceable === true || data.Status === "Success";
    if (ok) {
      this.showSuccess(data.message || undefined);
    } else {
      this.showError(
        data.message || this.msg("msgNotServiceable", "Pincode not serviceable."),
      );
    }
  }

  async checkViaPostal(pincode) {
    const response = await fetch(
      `https://api.postalpincode.in/pincode/${pincode}`,
    );
    if (!response.ok) {
      this.showError(this.msg("msgServerError", "Server error. Please try again later."));
      return;
    }
    const data = await response.json();
    if (data[0]?.Status === "Success") {
      this.showSuccess();
    } else {
      this.showError(this.msg("msgNotServiceable", "Pincode not serviceable."));
    }
  }

  async checkPincode() {
    const pincode = this.input.value.trim();
    this.hideAll();

    if (pincode.length < 6) {
      this.showError(this.msg("msgInvalidLength", "Please enter a 6 digit pincode."));
      this.input.value = "";
      return;
    }

    if (!this.isValidPincodeFormat(pincode)) {
      this.showError(
        this.msg("msgInvalidFormat", "Please enter a valid numeric pincode."),
      );
      this.input.value = "";
      return;
    }

    try {
      if (this.apiUrl) {
        await this.checkViaEscapeApi(pincode);
      } else {
        await this.checkViaPostal(pincode);
      }
    } catch {
      this.showError(
        this.msg("msgGenericError", "Something went wrong. Please try again."),
      );
    }
  }
}

if (!customElements.get("escape-pincode-checker")) {
  customElements.define("escape-pincode-checker", EscapePincodeChecker);
}
